import { Button } from "@/src/components/buttons";
import { openConfirmDialog, openDrawer } from "@/src/components/dialogs";
import Loading from "@/src/components/loading";
import apiFetch from "@/src/utils/apiFetch";
import { getHospitalId } from "@/src/utils/utils";
import { title } from "process";
import { useEffect, useRef, useState } from "react";
import src from "react-select";
import BiologyIframe from "./biologyIframe";

export function BiologyIframesButton({}: {}) {
  return (
    <Button type="tertiary" color="orange" onClick={async () => {}}>
      Laboratoires
    </Button>
  );
}

export async function openLabChoiceDrawer() {
  let services = await apiFetch("services", "loadIframeServices", {
    hospitalId: getHospitalId(),
  });
  await openDrawer({
    id: "labChoiceDrawer",
    title: "Consulter les résultats de Laboratoires",
    content: (
      <div className="c1 gap15">
        <div className="gray center p20">
          Veuillez choisir le laboratoire pour afficher les résultats
        </div>
        {services?.map((service) => {
          return (
            <Button
              key={service.id}
              type="tertiary"
              color="orange"
              onClick={async () => {
                if (!service.iframeUrl) throw new Error("Aucune url spécifiée");
                window.open(service.iframeUrl, "_blank");
                openConfirmDialog({
                  title: "Consulter les résultats de Laboratoires",
                  content:
                    "La plateforme de laboratoire a été développée par la société BMLab et n'est pas gérée par la plateforme REMED. \n\n En cas de problème lors du chargement de la fenêtre, prière de contacter la société BMLab ou le laboratoire en question.",
                });

                // await openDrawer({
                //   id: "biologyIframeDrawer",
                //   additionalClasses: ["big", "noPadding"],

                //   title: (
                //     <div className="c1 gap10">
                //       <div className="bold">{service.name}</div>
                //       <div className="gray f13">
                //         En cas de problème lors du chargement de la fênetre
                //         veuillez contacter la société BMLab (Plateforme de
                //         laboratoire).
                //       </div>
                //     </div>
                //   ),
                //   content: <BiologyIframe url={service.iframeUrl} />,
                // });
              }}
            >
              {service.name}
            </Button>
          );
        })}
      </div>
    ),
  });
}
